import axios from 'axios';
import alt   from '../alt/alt.js';

class DataActions {
  constructor() {
    // const appUrl = 'http://localhost:8888/moldarchitects/wp'; // Wordpress installation url
    const appUrl = process.env.REACT_APP_API_URL;

    this.pagesEndPoint = `${appUrl}/wp-json/wp/v2/pages`; // Endpoint for getting Wordpress Pages
    this.postsEndPoint = `${appUrl}/wp-json/wp/v2/posts`; // Endpoint for getting Wordpress Posts
    this.projectsEndPoint = `${appUrl}/wp-json/wp/v2/projects-api/?per_page=100`; // Endpoint for getting Projects
  }

  // Method for getting data from the provided end point url
  api(endPoint) {
    return new Promise((resolve, reject) => {
      axios.get(endPoint).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  // Method for getting Pages data
  getPages(cb){
    this.api(this.pagesEndPoint).then((response)=>{
      this.getProjects(response, cb)
    });
    return true;
  }

  getProjects(pages, cb){
    this.api(this.projectsEndPoint).then((response)=>{
      this.getPosts(pages, response, cb)
    });
    return true;
  }

  // Method for getting Posts data
  getPosts(pages, projects, cb){
    this.api(this.postsEndPoint).then((response)=>{
      const posts     = response
      const payload   = { pages, projects, posts };

      this.getSuccess(payload); // Pass returned data to the store
      cb(payload); // This callback will be used for dynamic rout building
    });
    return true;
  }

  // This returnes an object with Pages and Posts data together
  // The Alt Store will listen for this method to fire and will store the returned data
  getSuccess(payload){
    return payload;
  }
}

export default alt.createActions(DataActions);



// WEBPACK FOOTER //
// ./src/scripts/flux/actions/DataActions.js